import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-circle",
  "use": "plus-circle-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" id=\"plus-circle\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.5 0a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm1 5.705V4.41h-2v3.295H5.205v2H8.5V13h2V9.705h3.295v-2H10.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol